const View = require("presto-ui").baseView;
const dom = require("presto-ui").doms;

const LinearLayout = require("presto-ui").views.LinearLayout;
const ImageView = require("presto-ui").views.ImageView;
const TextView = require("presto-ui").views.TextView;

const Config = require('./../../globalConfig');
const Controller = require('./../../controller/pages/Main/Home2');
const Strings = require('./../../res/string');
const Accessibility = require('./../../res/accessibility');
const Font = require('./../../res/fontStyle');
const Color = require('./../../res/color');
const FontSize = require('./../../res/fontSize');
const FontColor = require('./../../res/fontColor');

class Home2 extends Controller {

	constructor(props, children, state) {
		super(props, children, state);
		this.STR = Strings();
		this.HINT = Accessibility();
	}

	onPop = () => {}

	render = () => {
		this.layout = (
			<LinearLayout
				id={this.id("Content")}
				height="match_parent"
				width="match_parent"
				orientation="vertical"
				gravity="center_horizontal"
				background={Color.A__FFFFFFFF}
				cornerRadius="0"
				root={true}
				style={this.style_Content}>
				<LinearLayout
					id={this.id("HeaderGroup")}
					height="170"
					width="match_parent"
					orientation="horizontal"
					gravity="center_vertical"
					padding="100,60,100,60"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_HeaderGroup}>
					<ImageView
						id={this.id("JuspayUniveristyLogo")}
						height="40"
						width="333"
						imageUrl="juspayuniveristylogo48"
						style={this.style_JuspayUniveristyLogo} />
					<LinearLayout
						id={this.id("NavBarGroup")}
						height="50"
						width="518"
						orientation="horizontal"
						margin="389,0,0,0"
						weight="1"
						style={this.style_NavBarGroup}>
						<TextView
							id={this.id("RegisterText")}
							height="33"
							width="92"
							margin="0,9,0,0"
							text={this.STR.Register1}
							textSize={FontSize.A_24}
							color={FontColor.A__FF3A3A3A}
							fontStyle={Font.AVENIR_ROMAN}
							gravity="center"
							style={this.style_RegisterText} />
						<TextView
							id={this.id("ForumText")}
							height="33"
							width="72"
							margin="76,9,0,0"
							text={this.STR.Forum2}
							textSize={FontSize.A_24}
							color={FontColor.A__FF3A3A3A}
							fontStyle={Font.AVENIR_ROMAN}
							gravity="center"
							style={this.style_ForumText} />
						<LinearLayout
							id={this.id("LetsStartGroup")}
							height="50"
							width="200"
							orientation="vertical"
							padding="0,9,0,8"
							margin="78,0,0,0"
							weight="1"
							background={Color.A__FFEE0000}
							cornerRadius="4"
							style={this.style_LetsStartGroup}>
							<TextView
								id={this.id("LetsStartText")}
								height="33"
								width="match_parent"
								text={this.STR.LetsStartText74}
								textSize={FontSize.A_24}
								color={FontColor.A__FFFFFFFF}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="center"
								style={this.style_LetsStartText} />
						</LinearLayout>
					</LinearLayout>
				</LinearLayout>
				<LinearLayout
					id={this.id("HeroGroup")}
					height="730"
					width="match_parent"
					orientation="horizontal"
					padding="85,56,85,110"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_HeroGroup}>
					<ImageView
						id={this.id("HeroVideoGroup")}
						height="564"
						width="569"
						imageUrl="herovideogroup47"
						style={this.style_HeroVideoGroup} />
					<LinearLayout
						id={this.id("HeroTextGroup")}
						height="366"
						width="635"
						orientation="vertical"
						margin="66,83,0,0"
						weight="1"
						style={this.style_HeroTextGroup}>
						<TextView
							id={this.id("Hero_Epic")}
							height="144"
							width="match_parent"
							text={this.STR.Hero_Epic75}
							textSize={FontSize.A_60}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_BLACK}
							lineHeight="72px"
							gravity="left"
							style={this.style_Hero_Epic} />
						<TextView
							id={this.id("Section_body")}
							height="128"
							width="match_parent"
							margin="0,30,0,0"
							text={this.STR.Section_body76}
							textSize={FontSize.A_18}
							color={FontColor.A__FF3A3A3A}
							fontStyle={Font.ROBOTOMONO_REGULAR}
							lineHeight="32px"
							gravity="left"
							style={this.style_Section_body} />
						<TextView
							id={this.id("Jump_in___get_starte")}
							height="32"
							width="240"
							margin="0,32,0,0"
							text={this.STR.Jump_in___get_starte77}
							textSize={FontSize.A_18}
							color={FontColor.A__FFEE0000}
							fontStyle={Font.ROBOTOMONO_BOLD}
							lineHeight="32px"
							gravity="left"
							style={this.style_Jump_in___get_starte} />
					</LinearLayout>
				</LinearLayout>
				<LinearLayout
					id={this.id("PrestoSectionGroup")}
					height="900"
					width="match_parent"
					orientation="vertical"
					gravity="center_horizontal"
					padding="0,109,0,0"
					background={Color.A__19BBBBBB}
					cornerRadius="0"
					style={this.style_PrestoSectionGroup}>
					<TextView
						id={this.id("PrestoSectionText")}
						height="55"
						width="match_parent"
						text={this.STR.PrestoSectionText78}
						textSize={FontSize.A_40}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_BLACK}
						gravity="center"
						style={this.style_PrestoSectionText} />
					<LinearLayout
						id={this.id("BrandsGroup")}
						height="93"
						width="1196"
						orientation="horizontal"
						padding="38,0,0,0"
						margin="0,109,0,0"
						background={Color.A__00FFFFFF}
						cornerRadius="0"
						style={this.style_BrandsGroup}>
						<ImageView
							id={this.id("BhimGroup")}
							height="93"
							width="221"
							imageUrl="bhimgroup41"
							style={this.style_BhimGroup} />
						<ImageView
							id={this.id("JuspaySafeGroup")}
							height="93"
							width="244"
							margin="217,0,0,0"
							imageUrl="juspaysafegroup43"
							style={this.style_JuspaySafeGroup} />
						<LinearLayout
							id={this.id("Space")}
							weight="1"
							style={this.style_Space} />
						<ImageView
							id={this.id("JusPayFuelGroup")}
							height="93"
							width="261"
							imageUrl="juspayfuelgroup45"
							style={this.style_JusPayFuelGroup} />
					</LinearLayout>
					<TextView
						id={this.id("PrestoSectionHelpText")}
						height="256"
						width="match_parent"
						margin="0,100,0,0"
						text={this.STR.PrestoSectionHelpText79}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.ROBOTOMONO_REGULAR}
						lineHeight="32px"
						gravity="center"
						style={this.style_PrestoSectionHelpText} />
					<TextView
						id={this.id("LearnPrestoText")}
						height="24"
						width="match_parent"
						margin="0,50,0,0"
						text={this.STR.LearnPrestoText80}
						textSize={FontSize.A_18}
						color={FontColor.A__FFED0000}
						fontStyle={Font.ROBOTOMONO_BOLD}
						gravity="center"
						style={this.style_LearnPrestoText} />
				</LinearLayout>
				<LinearLayout
					id={this.id("WhatCourseGroup")}
					height="777"
					width="match_parent"
					orientation="vertical"
					gravity="center_horizontal"
					padding="0,100,0,100"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_WhatCourseGroup}>
					<TextView
						id={this.id("WhatCourseText")}
						height="72"
						width="match_parent"
						text={this.STR.WhatCourseText81}
						textSize={FontSize.A_40}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_BLACK}
						lineHeight="72px"
						gravity="center"
						style={this.style_WhatCourseText} />
					<LinearLayout
						id={this.id("Space100000000ø")}
						weight="1"
						style={this.style_Space100000000ø} />
					<LinearLayout
						id={this.id("CourseGroup")}
						height="445"
						width="1200"
						orientation="horizontal"
						style={this.style_CourseGroup}>
						<LinearLayout
							id={this.id("CurriculumGroup")}
							height="445"
							width="500"
							orientation="vertical"
							weight="1"
							background={Color.A__FFFFFFFF}
							cornerRadius="0"
							style={this.style_CurriculumGroup}>
							<TextView
								id={this.id("CurriculumText")}
								height="33"
								width="match_parent"
								text={this.STR.CurriculumText82}
								textSize={FontSize.A_24}
								color={FontColor.A__FFED0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_CurriculumText} />
							<ImageView
								id={this.id("Open_book")}
								height="120"
								width="162"
								margin="0,40,0,0"
								imageUrl="openbook39"
								style={this.style_Open_book} />
							<LinearLayout
								id={this.id("Space200000000ø")}
								weight="1"
								style={this.style_Space200000000ø} />
							<TextView
								id={this.id("CurriculumHelpText")}
								height="192"
								width="match_parent"
								text={this.STR.CurriculumHelpText83}
								textSize={FontSize.A_18}
								color={FontColor.A__FF3A3A3A}
								fontStyle={Font.ROBOTOMONO_REGULAR}
								lineHeight="32px"
								gravity="left"
								style={this.style_CurriculumHelpText} />
						</LinearLayout>
						<LinearLayout
							id={this.id("ProjectGroup")}
							height="349"
							width="500"
							orientation="vertical"
							margin="200,0,0,0"
							weight="1"
							background={Color.A__FFFFFFFF}
							cornerRadius="0"
							style={this.style_ProjectGroup}>
							<TextView
								id={this.id("ProjectText")}
								height="33"
								width="match_parent"
								text={this.STR.Project31}
								textSize={FontSize.A_24}
								color={FontColor.A__FFED0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_ProjectText} />
							<ImageView
								id={this.id("School_material")}
								height="120"
								width="120"
								margin="0,40,0,0"
								imageUrl="schoolmaterial40"
								style={this.style_School_material} />
							<LinearLayout
								id={this.id("Space300000000ø")}
								weight="1"
								style={this.style_Space300000000ø} />
							<TextView
								id={this.id("ProjectHelpText")}
								height="96"
								width="match_parent"
								text={this.STR.ProjectHelpText84}
								textSize={FontSize.A_18}
								color={FontColor.A__FF3A3A3A}
								fontStyle={Font.ROBOTOMONO_REGULAR}
								lineHeight="32px"
								gravity="left"
								style={this.style_ProjectHelpText} />
						</LinearLayout>
					</LinearLayout>
				</LinearLayout>
				<LinearLayout
					id={this.id("FooterGroup")}
					height="423"
					width="match_parent"
					orientation="vertical"
					gravity="center_horizontal"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_FooterGroup}>
					<LinearLayout
						id={this.id("Footer")}
						height="270"
						width="1240"
						orientation="horizontal"
						padding="100,95,100,95"
						background={Color.A__FFEE0000}
						cornerRadius="0"
						style={this.style_Footer}>
						<TextView
							id={this.id("SoundsExcitingText")}
							height="80"
							width="580"
							weight="1"
							text={this.STR.SoundsExcitingText85}
							textSize={FontSize.A_24}
							color={FontColor.A__FFFFFFFF}
							fontStyle={Font.ROBOTOMONO_REGULAR}
							lineHeight="40px"
							gravity="left"
							style={this.style_SoundsExcitingText} />
						<LinearLayout
							id={this.id("LetsStartFooterGroup")}
							height="60"
							width="240"
							orientation="vertical"
							padding="48,10,0,9"
							margin="220,9,0,0"
							background={Color.A__FFFFFFFF}
							cornerRadius="4"
							style={this.style_LetsStartFooterGroup}>
							<TextView
								id={this.id("LetsStartFooterText")}
								height="41"
								width="144"
								text={this.STR.LetsStartText74}
								textSize={FontSize.A_30}
								color={FontColor.A__FFED0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="center"
								style={this.style_LetsStartFooterText} />
						</LinearLayout>
					</LinearLayout>
					<LinearLayout
						id={this.id("LastSpace")}
						height="153"
						width="match_parent"
						background={Color.A__FFFFFFFF}
						cornerRadius="0"
						style={this.style_LastSpace} />
				</LinearLayout>
			</LinearLayout>
		);
		this.containerId = this.layout.idSet.id;
		return this.layout.render();
	}

};

module.exports = Home2;



// WEBPACK FOOTER //
// ./views/Main/Home2.js